<ng-container *ngIf="entity?._id; then hasEntity; else noEntity"></ng-container>
<ng-template #hasEntity>

  <div [title]="entity?.email ?? entity?.name" class="flex-row flex-v-center">
    <profile class="user" [userId]="entity?._id" [userName]="entity?._id === unallocatedUserId ? unallocatedUserId : entity | fullName" [ngClass]="{ disabled: entity['disabled'] }"></profile>

    <div class="line-high-25">
      {{ entity | fullName:true }} <span class="text-danger" title="Missing or Expired Compliance" *ngIf="entity['disabled']"><i class="fa  fa-exclamation-triangle"></i></span>
    </div>

    <div *ngIf="clearTemplate" class="view-template">
      <span class="ng-value-icon right" (click)="onClear(entity)" aria-hidden="true">×</span>
    </div>
  </div>


</ng-template>

<ng-template #noEntity>
  <span class="empty-field">{{ emptyText }}</span>
</ng-template>